var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Portal } from '../portal';
import { toastsListStyle } from './styles';
function ToastsList(_a) {
    var offset = _a.offset, children = _a.children;
    return (_jsx(Portal, { children: _jsx("ul", __assign({ "data-testid": "toasts-list", css: toastsListStyle({ offset: offset }) }, { children: children })) }));
}
export default ToastsList;
